import React from 'react';
import { ReactComponent as Success } from '@/assets/images/svg/success.svg';
import { Button } from '@/components';

interface QrCodeContentProps {
  qrCode: string;
  url?: string;
  onCopyUrl?: (url: string) => void;
}

export const QrCodeContent: React.FC<QrCodeContentProps> = ({ qrCode, url, onCopyUrl }) => (
  <div className="filter-modal-content">
    <div className="exclude-container">
      <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
        <Success color="#E64F49" style={{ width: 40 }} />{' '}
        <h5 className="modal__confirmation-title">Seu Pedido foi realizado com sucesso</h5>
      </div>
      <div
        className="modal__confirmation-text"
        style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '20px' }}
      >
        <h6 style={{ maxWidth: '300px', marginRight: '20px' }}>
          Para concluir o pagamento, efetue a leitura do <strong>QrCode</strong> abaixo na POS.
        </h6>
        <img src={qrCode} style={{ width: '300px' }} />
      </div>
      {url && onCopyUrl && (
        <>
          <div>
            Para concluir o pagamento, click sobre o <strong>link</strong> abaixo.
          </div>
          <div>
            <a href="#" onClick={() => window.open(url, '_blank')}>
              {url}
            </a>
          </div>
          <div style={{ marginTop: '30px' }}>
            <Button title="Copiar Link" onClick={() => onCopyUrl(url)} />
          </div>
        </>
      )}
    </div>
  </div>
);
